/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![RetryIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABpElEQVR4nNVVS0oDQRAdxb8X8XOIQSGQxdRnxE7ViBhFiBpF9AS5guBeXCq60SMYste4V3Qhihs3Jkulk3QIajJJSMA8GBi6u+pV1+e15/0n+L4/ksvlhnvmMAiCKSDZBJZrZHlF1i/7AckLsFwByboxZrLRBlgLSJKP8z2EmNpAlnfntNlXJdPIGbr1pp4zmcwokpzWnZDeAsseopmzKbL7zDJr14Cl2HDu2KYvlgBYT6oGUiaKtlrl3O4Byw6Qlqq30aOWBIipNec84MiPy2M9qFAXHUlTAlssIHmrHdj2OkRAUbYlAbCmXc5tkWOjZi20Kv4vA2S5tBs2knYiRpJ8085ivfmDQJ8qBEvRjNcPIEnZEvwcnMEhANbHvqYIWC4qRQp1ty8ERLJS7QK566liOvjp9ITrpG4GrS1gKKamKSXE1EJ7Vh3CqmJdjyjKxomdPQOkH0B60BZBRXIdCduplKKTa9vCicTqNIDOY6j7SHpfn2DUw85uEooB1ue4B6dSN9Rlrxskk8lxDFMKrGfI+lAbxs/a/7l9yYwxY105Hxh8A4+EGzC0FnuQAAAAAElFTkSuQmCC)
 */
export const RetryIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M4 12a8 8 0 0 1 14.93-4H15a1 1 0 1 0 0 2h6a1 1 0 0 0 1-1V3a1 1 0 1 0-2 0v3a9.98 9.98 0 0 0-18 6 10 10 0 0 0 16.29 7.78 1 1 0 0 0-1.26-1.56A8 8 0 0 1 4 12Z"
        className={colorClass}
      />
    </svg>
  );
};
